import React from 'react';

const Add = props => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="21"
    height="20"
    viewBox="0 0 21 20"
  >
    <path
      // eslint-disable-next-line react/prop-types
      fill={props.color || '#108EE9'}
      fillRule="nonzero"
      d="M11.833 9.167h5.834a.833.833 0 1 1 0 1.666h-5.834v5.834a.833.833 0 1 1-1.666 0v-5.834H4.333a.833.833 0 1 1 0-1.666h5.834V3.333a.833.833 0 1 1 1.666 0v5.834z"
    />
  </svg>
);

export default Add;
